<p-dialog 
	[(visible)]="visible" 
	[style]="{width: '500px', maxWidth: '90vw'}"
	[header]="'hearingRequest.title' | translate"
	[modal]="true"
	[closable]="true"
	[draggable]="false"
	[resizable]="false"
	styleClass="hearing-request-dialog">
	
	<div class="dialog-content">
		<!-- Success Icon -->
		<div class="success-icon-container">
			<i class="pi pi-check-circle success-icon"></i>
		</div>
		
		<!-- Message -->
		<div class="message-container">
			<p class="success-message">{{ message }}</p>
		</div>
		
		<!-- Action Buttons -->
		<div class="action-buttons">
			<button 
				type="button" 
				pButton 
				class="p-button p-button-success hearing-btn"
				(click)="openHearingUrl()"
				[label]="'hearingRequest.goToHearing' | translate">
				<i class="pi pi-external-link"></i>
			</button>
			
			<button 
				type="button" 
				pButton 
				class="p-button p-button-outlined close-btn"
				(click)="closeDialog()"
				[label]="'hearingRequest.close' | translate">
			</button>
		</div>
	</div>
</p-dialog>